import React from 'react';

interface IProps {
    key: number;
}

const CampaignPlanLoader = ({ key }: IProps) => {
    return (
        <div
            key={key}
            className="tw-w-[328px] tw-h-[328px] tw-bg-gray-300 tw-rounded tw-shadow"
        ></div>
    );
};

export default CampaignPlanLoader;
